import { SIMPLE_SURVEY_STATUS } from './constants/SurveysTypes';

export const checkIsSimpleSurveyStatus = (surveyStatus) => surveyStatus === SIMPLE_SURVEY_STATUS;
